import React from 'react';
import PropTypes from 'prop-types';
import { Popup } from '@techsoftware/happay-widgets';
import Plus from '../../assets/images/combined-shape.svg';
import history from '../../utils/history';
export default class MegamenuCreation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.handleMenuItemClick = this.handleMenuItemClick.bind(this);
  }

  setWrapperRef = node => {
    this.wrapperRef = node;
  };

  _handleTouchTap() {
    this.setState({ open: !this.state.open });
  }

  handleMenuItemClick(event) {
    if (event.target.dataset) {
      const { name } = event.target.dataset;
      switch (name) {
        case 'newUser':
          history.push('/people/addnewpeople');
          break;
        case 'newCard':
          history.push('/card/assigncards');
          break;
        case 'requestCard':
          history.push('/card/usedbyme?requestcard');
          break;
        case 'payBill':
          history.push('/balance?showPayData');
          break;
        default:
          break;
      }
    }
    this.setState({ open: false });
    event.preventDefault();
    event.stopPropagation();
  }

  render() {
    return (
      <div ref={this.setWrapperRef} className="mega-menu">
        <div
          className="mega-menu-circle"
          onClick={eve => {
            eve.preventDefault();
            eve.stopPropagation();
            this._handleTouchTap();
          }}
        >
          {this.state.open ? (
            <img
              src={Plus}
              style={{
                transform: 'rotate(45deg)',
                transition: 'all 0.5s ease',
              }}
              alt="plus icon"
            />
          ) : (
            <img
              src={Plus}
              id="megaMenuButton"
              style={{ transition: 'all 0.5s ease' }}
              alt="plus icon"
            />
          )}
        </div>
        <Popup
          id="megaMenuPopup"
          parentElementId="megaMenuButton"
          open={this.state.open}
          onClose={ev => {
            // console.log(this.state.open,'83')
            // if(this.state.open){
            //   this.setState({ open:false });
            // }
          }}
          pointerPlacement="left-top"
          popupStyle={{
            width: '220px',
            padding: '20px 0px',
            left: '30px',
            top: '70px',
          }}
          variant="scroll"
        >
          <div onClick={this.handleMenuItemClick}>
            {this.props.megaMenuList.map((item, i) => (
              <div className="menu-box body" data-name={item.key}>
                {item.name}
              </div>
            ))}
          </div>
        </Popup>
      </div>
    );
  }
}

MegamenuCreation.propTypes = {
  megaMenuList: PropTypes.array,
  // getContainerDraftId: PropTypes.func,
  // isCollapsed: PropTypes.bool,
};

MegamenuCreation.defaultProps = {
  megaMenuList: [],
  // getContainerDraftId: () => {},
  // isCollapsed: false,
};
